import {API_URL, dataGet} from '../api'

export const getProCount = async () => {
    return await dataGet(API_URL, `admin/pro/count`)
}
